import { AxiosResponse } from 'axios';
import { FilterOptions } from '../../hooks/useFilters';
import { RestServiceConnection } from '../restServiceConnection';

const INVOICE_ENDPOINT = '/invoice';

export class InvoiceService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene el listado de facturas
     *
     * @EN Gets the list of invoices
     * 
     * @param filters
     */
    // -------------------------------------------------------------------------------------------------------------
    listInvoices = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: INVOICE_ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene la información de una factura por su ID
     *
     * @EN Gets the information of an invoice by its ID
     *
     * @param invoiceId
     */
    // -------------------------------------------------------------------------------------------------------------
    getInvoiceById = async (invoiceId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: INVOICE_ENDPOINT + '/get',
            data: { id: invoiceId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Crea una factura con la información proporcionada
     *
     * @EN Creates an invoice with the provided information
     *
     * @param invoice
     */
    // -------------------------------------------------------------------------------------------------------------
    createInvoice = async (invoice: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: INVOICE_ENDPOINT + '/create',
            data: invoice,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Edita una factura con la información proporcionada
     *
     * @EN Edits an invoice with the provided information
     *
     * @param invoice
     */
    // -------------------------------------------------------------------------------------------------------------
    editInvoice = async (invoice: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: INVOICE_ENDPOINT + '/edit',
            data: invoice,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Elimina una factura existente en el sistema
     *
     * @EN Deletes an existing invoice from the system
     *
     * @param ids
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteInvoice = async (ids: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: INVOICE_ENDPOINT + '/delete',
            data: { ids: [ids] },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Elimina varias facturas existentes en el sistema
     *
     * @EN Deletes multiple existing invoices from the system
     *
     * @param invoiceIds
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiInvoices = async (invoiceIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: INVOICE_ENDPOINT + '/delete',
            data: { ids: invoiceIds },
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Marca una o varias facturas como pagadas en el sistema
     *
     * @EN Marks one or more invoices as paid in the system
     *
     * @param ids
     */
    // -------------------------------------------------------------------------------------------------------------
    paidInvoice = async (ids: string[], companyId?: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: INVOICE_ENDPOINT + '/paid',
            data: { ids: ids },
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Cancela una o varias facturas existentes en el sistema
     *
     * @EN Cancels one or more existing invoices from the system
     *
     * @param ids
     * @param reason
     */
        // ---------------------------------------------------------------------------------------------------------
    cancelInvoice = async (ids: string[], reason: string | undefined) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: INVOICE_ENDPOINT + '/cancel',
            data: { ids: ids, reason: reason },
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene el listado de facturas de un cliente
     *
     * @EN Gets the list of invoices of a client
     * 
     * @param filters
     */
    //-------------------------------------------------------------------------------------------------------------
    listClientInvoices = async (filters: FilterOptions) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: INVOICE_ENDPOINT + '/list-invoices',
            data: filters,
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE USUARIOS
     * @EN GETS THE LIST OF USERS
     * 
     * @param filters
     */
    // -------------------------------------------------------------------------------------------------------------
    listForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: INVOICE_ENDPOINT + '/list-select',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Exporta las facturas de un cliente a un archivo Excel
     * @EN Exports the invoices of a client to an Excel file
     * 
     * @param filters
     */
    // -------------------------------------------------------------------------------------------------------------
    exportInvoicesToExcel = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: INVOICE_ENDPOINT + '/export-to-excel',
            data: filters,
            responseType: 'blob'
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Exporta las facturas de un cliente a un archivo Excel
     * @EN Exports the invoices of a client to an Excel file
     * 
     * @param filters
     */
    // -------------------------------------------------------------------------------------------------------------
    exportMultiInvoicesToPDF = async (ids?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: INVOICE_ENDPOINT + '/export-multi',
            data: {
                ids: ids
            },
            responseType: 'blob'
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Exporta las facturas de un cliente a un archivo Excel
     * @EN Exports the invoices of a client to an Excel file
     * 
     * @param filters
     */
    // -------------------------------------------------------------------------------------------------------------
    exportInvoicesByDateToPDF = async (dateRange?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: INVOICE_ENDPOINT + '/export-by-dates',
            data: {
                date: dateRange
            },
            responseType: 'blob'
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}